// src/components/sections/Team.js
// This is a section component that displays team members on the homepage

// src/components/sections/Team.js - Updated with direct S3 URLs
import React from 'react';
import { Link } from 'react-router-dom';
import TeamCard from '../ui/TeamCard';

// Base S3 URL for your bucket
const S3_BASE_URL = 'https://amvlawwebsitefa905-dev.s3.ap-south-1.amazonaws.com';

// Team member data with direct S3 URLs for images
const teamMembers = [
  {
    id: 'mehak-gupta',
    name: 'Mehak Gupta',
    position: 'Managing Partner',
    specialization: 'Civil, Commercial & Matrimonial Litigation',
    education: 'Post graduation and Master\'s degree in Law from BVP, Pune',
    // Direct S3 URL
    image: `${S3_BASE_URL}/assets/images/team/mehak-gupta.jpeg`,
    bio: 'Adv. Mehak Gupta is a distinguished and accomplished Advocate with a stellar career spanning over a decade. Her unwavering commitment to upholding justice, coupled with her innate sense of values and passion for truth, has earned her a reputable standing in the legal fraternity.',
    contact: {
      phone: '9990358009',
      email: 'mehakgupta@amvlaw.io',
      linkedin: 'www.linkedin.com/in/mehakguptaamvlaw'
    },
    color: 'primary'
  },
  {
    id: 'vibhor-gupta',
    name: 'Vibhor Gupta',
    position: 'Managing Partner',
    specialization: 'White-Collar Crimes, Criminal Defense, Property Law',
    education: 'Alumnus of Campus Law Centre, Delhi University',
    // Direct S3 URL
    image: `${S3_BASE_URL}/assets/images/team/vibhor-gupta.jpeg`,
    bio: 'Adv. Vibhor Gupta, an alumnus of Campus Law Centre, Delhi University (CLC, DU), is a go-to litigator and strategist specializing in White-Collar Crimes, Criminal Defense, and Property Law. With expertise in trial strategy, cross-examination, and bails, he provides comprehensive legal defense for the accused in cases led by CBI, ED, SFIO, and GST authorities.',
    contact: {
      phone: '9910508654',
      email: 'vibhorgupta@amvlaw.io',
      linkedin: 'www.linkedin.com/in/vibhorguptaamvlaw'
    },
    color: 'secondary'
  },
  {
    id: 'vikas-sharma',
    name: 'Vikas Sharma',
    position: 'Legal Consultant',
    specialization: 'Customs Law, International Trade Regulations',
    education: 'Former Customs Officer',
    // Direct S3 URL
    image: `${S3_BASE_URL}/assets/images/team/vikas-sharma.jpeg`,
    bio: 'Adv. Vikas Sharma, originally from Allahabad, began his career as a Customs Officer in Mumbai, gaining firsthand insight into the complexities of customs regulations and enforcement. Driven by a passion for justice, he transitioned into law, bringing his in-depth regulatory knowledge and enforcement experience to the courtroom.',
    color: 'primary'
  }
];

const TeamSection = () => {
  return (
    <section id="team" className="py-16 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">Our Legal Team</h2>
          <div className="w-20 h-1 bg-secondary mx-auto my-4"></div>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            Meet our team of experienced advocates and legal professionals dedicated to your success
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {teamMembers.slice(0, 3).map((member, index) => (
            <TeamCard
              key={member.id}
              name={member.name}
              position={member.position}
              bio={member.bio}
              image={member.image}
              color={member.color}
              index={index}
              contact={member.contact}
            />
          ))}
        </div>
        
        <div className="mt-8 text-center">
          <Link
            to="/team"
            className="inline-block bg-primary hover:bg-primary-dark text-white px-6 py-3 rounded font-medium transition-colors"
          >
            View All Team Members
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;